import type { TileImage, Variation } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-title/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { type LayoutImageIntents, getLayoutImages } from '@tilelist/layouts/mapping/LayoutImages.ts';
import { mapFashionTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';
import { mapLink } from '../mapping/ProductLink';

export type FashionLayout = {
    /**
 *
 */
    readonly variation: Variation;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];

    readonly primaryImage: TileImage;
};

/**
 *
 */
export function createFashionLayout(variation: Variation, intents?: LayoutImageIntents): FashionLayout {
    const { images, primaryImage } = getLayoutImages(variation, intents);
    return {
        variation,
        title: mapFashionTitle(variation),
        link: mapLink(variation),
        images,
        primaryImage,
    };
}
